<template>
        <section class="tendencies">
            <scroll-to-me @trigger-animate="toggleTendenciesTitle">
                <h3 class="tendencies__title" data-anime="fade-up" :class="{animate: showTitle}">Inspire-se</h3>
            </scroll-to-me>

            <scroll-to-me @trigger-animate="toggleTendenciesSubtitle">
                <h2 class="tendencies__subtitle" data-anime="fade-up" :class="{animate: showSubtitle}">
                    {{$root.commonTexts['home.tendencias.titulo']}}</h2>
            </scroll-to-me>

            <scroll-to-me @trigger-animate="toggleTendenciesText">
                <p class="tendencies__text" data-anime="fade-up" :class="{animate: showText}">
                    {{$root.commonTexts['home.tendencias.texto']}}</p>
            </scroll-to-me>

            <scroll-to-me @trigger-animate="toggleTendencies">
                <div v-if="ambientes.length" class="wrapper" :class="{animate: showTendencies}"
                     data-anime="fade-up">
                    <div class="item" :key="index + 'tendencieambiente'" v-for="(tendencie, index) in ambientes">
                        <lazy-image bg-mode :image="tendencie.images[0]"/>
                        <div class="item__content">
                            <h3 v-if="tendencie.name !== null" class="item__content__title">{{tendencie.name}}</h3>
                            <p v-if="tendencie.ambientes.length" class="item__content__desc">
                                {{tendencie.ambientes[0].name}}</p>
                            <div @click="openModal(index)" class="item__content__btn">Mais detalhes</div>
                        </div>
                    </div>
                </div>
            </scroll-to-me>

            <div class="modal"
                 @click="outsideClick"
                 v-if="ambientes.length"
                 :class="{active: toggleModal}">
                <div class="modal-container">
                    <div class="modal__image">
                        <div class="modal__image__img">
                            <lazy-image bg-mode :image="ambientes[modalOffset].images[imageOffset]"/>
                        </div>
                        <div class="modal__image__list" v-if="ambientes[modalOffset].images">
                            <div class="modal__image__list__item"
                                 :key="index + 'homeTendenciesmodal'"
                                 v-for="(image, index) in ambientes[modalOffset].images">
                                <lazy-image @click.native="imageOffset = index"
                                            v-if="image.permalink !== null"
                                            :class="{active: imageOffset === index}"
                                            :image="image"/>
                            </div>
                        </div>
                    </div>
                    <div class="modal__content" v-if="ambientes.length">
                        <span v-if="0" class="modal__flag">lançamento</span>
                        <h2 class="modal__content__title">{{ambientes[modalOffset].name}}</h2>
                        <!--                    <h3>Produtos do ambiente</h3>-->
                        <vue-markdown :source="ambientes[modalOffset].description"
                                      class="modal__content__desc"></vue-markdown>
                        <router-link @click.native="enableScroll"
                                     :to="{ name: 'produto', params: { id: product.friendly_url || product.id }}"
                                     class="send_btn env-btn"
                                     :key="index + 'hometendenciesproducts'"
                                     v-for="(product, index) in ambientes[modalOffset].products">
                            {{product.name}}
                        </router-link>
                    </div>
                    <div class="modal__close">
                        <img @click="toggleModal = false" src="@/assets/icons/close.svg" alt="">
                    </div>
                </div>
            </div>
        </section>
</template>

<script>
    import ScrollToMe from "../../Shared/ScrollToMe";
    import VueMarkdown from 'vue-markdown';
    import LazyImage from "../../Shared/LazyImage";

    export default {
        name: "HomeTendencies",
        data() {
            return {
                tendencies: [],
                showTitle: false,
                showSubtitle: false,
                showText: false,
                showTendencies: false,
                ambientes: [],
                toggleModal: false,
                modalOffset: 0,
                imageOffset: 0,
                myBody: '',
            }
        },
        components: {
            ScrollToMe,
            VueMarkdown,
            LazyImage
        },
        watch: {
            toggleModal() {
                this.toggleModal ? this.disableScroll() : this.enableScroll();
            },
            '$root.commonTexts': {
                handler: function () {
                    if (Object.keys(this.$root.sliders).length) {
                        this.setTendencias();
                    }
                },
                immediate: true
            },
            '$root.sliders': {
                handler: function () {
                    if (Object.keys(this.$root.commonTexts).length) {
                        this.setTendencias();
                    }
                },
                immediate: true
            }
        },
        methods: {
            disableScroll() {
                this.myBody.style.overflowY = 'hidden';
            },
            enableScroll() {
                this.myBody.style.overflowY = 'auto';
            },
            openModal(index) {
                this.imageOffset = 0;
                this.toggleModal = !this.toggleModal;
                this.modalOffset = index;
            },
            outsideClick({target, currentTarget}) {
                target === currentTarget ? this.toggleModal = false : '';
            },
            fetchAmbientes() {
                axios.get('/tendencia')
                    .then(r => {
                        this.ambientes = r.data.data;
                    })
            },
            setTendencias() {
                this.tendencies = [
                    {
                        title: this.$root.commonTexts['home.card1.titulo'],
                        desc: this.$root.commonTexts['home.card1.texto'],
                        image: {
                            src: this.$root.sliders.homecard1[0].permalink
                        }
                    },
                    {
                        title: this.$root.commonTexts['home.card2.titulo'],
                        desc: this.$root.commonTexts['home.card2.texto'],
                        image: {
                            src: this.$root.sliders.homecard2[0].permalink
                        }
                    },
                    {
                        title: this.$root.commonTexts['home.card3.titulo'],
                        desc: this.$root.commonTexts['home.card3.texto'],
                        image: {
                            src: this.$root.sliders.homecard3[0].permalink
                        }
                    },
                    {
                        title: this.$root.commonTexts['home.card4.titulo'],
                        desc: this.$root.commonTexts['home.card4.texto'],
                        image: {
                            src: this.$root.sliders.homecard4[0].permalink
                        }
                    },
                ];
            },
            toggleTendenciesTitle() {
                this.showTitle = true
            },
            toggleTendenciesSubtitle() {
                this.showSubtitle = true
            },
            toggleTendenciesText() {
                this.showText = true
            },
            toggleTendencies() {
                this.showTendencies = true;
            }
        },
        computed: {
            sorted() {
                return this.ambientes.forEach((item, index) => {
                })
            }
        },
        mounted() {
            this.fetchAmbientes()
            this.myBody = document.querySelector('body');
        }
    }
</script>

<style lang="scss" scoped>
    .env-btn {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.875rem;
    }

    .tendencies {
        margin-top: 20px;
        color: #2b2b2b;

        &__title {
            text-align: center;
            font-family: 'Open Sans', sans-serif;
            font-weight: 400;
            font-size: 1.125rem;
            margin-bottom: 10px;
        }

        &__subtitle {
            margin-bottom: 20px;
            font-family: 'HelveticaNeue', Arial, sans-serif;
            font-weight: 500;
            font-size: 2rem;
            text-align: center;
        }

        &__text {
            font-family: 'Open Sans', sans-serif;
            font-weight: 400;
            max-width: 1140px;
            text-align: center;
            margin: 0 auto 60px auto;
            padding: 0 15px;
            font-size: 1rem;
        }
    }

    .wrapper {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }


    .item {
        width: calc(50% - 5px);
        position: relative;
        flex-shrink: 0;
        margin-top: 5px;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        height: 600px;

        &__content {
            width: 400px;
            opacity: 0;
            top: 45%;
            padding: 40px 60px;
            position: absolute;
            left: 50%;
            transform: translate3d(-50%, -30%, 0);
            background: rgba(0, 0, 0, .8);
            text-align: center;
            transition: all .3s;

            &__title {
                font-family: "HelveticaNeueLight", sans-serif;
                font-weight: 300;
                font-size: 1.375rem;
                color: #fff;
                margin-bottom: 15px;
            }

            &__desc {
                font-family: "Open Sans", sans-serif;
                font-size: 0.875rem;
                color: #fff;
                margin-bottom: 40px;
                overflow: hidden;
            }

            &__btn {
                width: 160px;
                margin: 0 auto;
                border-radius: 19px;
                display: block;
                border: 1px solid #fff;
                padding: 10px 30px;
                color: #fff;
                outline: none;
                font-family: "Open Sans", sans-serif;
                font-size: 0.875rem;
                z-index: 0;
                position: relative;
                overflow: hidden;
                transition: all .2s;
                cursor: pointer;

                &::before {
                    position: absolute;
                    top: 0;
                    left: 0;
                    content: '';
                    display: block;
                    height: 100%;
                    width: 100%;
                    background: #fff;
                    z-index: -1;
                    transition: all .3s;
                    transform: translate3d(0, 100%, 0);
                }
            }
        }
    }

    .item__content__btn:hover {
        color: #000;
    }

    .item__content__btn:hover.item__content__btn::before {
        transform: translate3d(0, 0, 0);
    }

    .item:hover .item__content {
        opacity: 1;
        transform: translate3d(-50%, -45%, 0);
    }

    .modal {
        opacity: 0;
        transition: all .3s;
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background: rgba(0, 0, 0, .5);
        z-index: 100;

        &.active {
            opacity: 1;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .modal__close {
            position: absolute;
            right: 20px;
            top: 20px;
            cursor: pointer;
        }
    }

    .modal-container {
        opacity: 1;
        margin: 0 auto;
        width: 1140px;
        height: 720px;
        background: #fff;
        z-index: 1;
        display: flex;
        padding: 40px;
        border-radius: 4px;
        position: relative;
    }

    .modal__image {
        width: 560px;
        height: 640px;
        flex-shrink: 0;

        &__img {
            width: 560px;
            height: 560px;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            position: relative;
        }

        img {
            width: 100%;
        }

        &__list {
            margin-top: 30px;
            display: flex;
            align-items: center;
            overflow: auto;

            &__item {
                width: 80px !important;
                height: 60px;
                opacity: 0.7;
                cursor: pointer;
                margin-right: 15px;
                position: relative;

                &:hover {
                    opacity: 1;
                }

                &.active {
                    opacity: 1;
                }
            }
        }
    }

    .modal__content {
        margin-left: 40px;
        width: 100%;
        overflow: auto;

        &__title {
            font-family: HelveticaNeue, Arial, sans-serif;
            font-weight: 500;
        }

        h3 {
            font-family: HelveticaNeue, Arial, sans-serif;
            font-weight: 500;
            color: #aaa;
            margin-top: 20px;
        }

        &__desc {
            font-family: HelveticaNeue, Arial, sans-serif;
            font-weight: 500;
            color: #2b2b2b;
            margin-top: 10px;
        }
    }

    .modal__flag {
        display: block;
        text-transform: lowercase;
        font-family: "Open Sans";
        font-size: 0.875rem;
        border: 1px solid #2b2b2b;
        padding: 2px 5px;
        margin-bottom: 20px;
        text-align: center;
        width: 120px;
    }

    @media only screen and (max-width: 1440px) {
        .item {
            height: 420px;
        }
    }

    @media only screen and(max-width: 1200px) {
        .modal-container {
            width: 820px;
            height: auto;
            flex-direction: column;
        }

        .modal .modal__close {
            right: 12px;
            top: 12px;
        }

        .modal__content {
            margin-left: 0;
            margin-top: 40px;
        }

        .modal__image {
            width: 100%;
            height: 440px;
            flex-shrink: 0;
            margin-bottom: 20px;

            &__img {
                width: 100%;
                height: 360px;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center center;
                margin-right: 20px;
                border-radius: 4px;
            }

            img {
                width: 100%;
            }

            &__list {
                max-width: 100%;
                margin-top: 30px;
                display: flex;
                justify-content: space-between;

                &__item {
                    width: 80px !important;
                    height: 80px;
                }
            }
        }
    }

    @media only screen and (max-width: 768px) {
        .item__content {
            width: 300px;
            padding: 30px 30px;
        }

        .modal-container {
            width: 680px;
            height: auto;
            flex-direction: column;
        }

        .modal .modal__close {
            right: 12px;
            top: 12px;
        }

        .modal__content {
            margin-left: 0;
            margin-top: 30px;
        }

        .modal__image {
            width: 100%;
            height: 440px;
            flex-shrink: 0;
            margin-bottom: 20px;

            &__img {
                width: 100%;
                height: 360px;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center center;
                margin-right: 20px;
            }

            img {
                width: 100%;
            }

            &__list {
                max-width: 100%;
                margin-top: 30px;
                display: flex;
                justify-content: space-between;

                &__item {
                    width: 60px !important;
                    height: 60px;
                }
            }
        }
    }

    @media only screen and(max-width: 767px) {
        .wrapper {
            flex-direction: column;
        }

        .tendencies {
            margin-top: 40px;
        }

        .item {
            width: 300px;
            margin: 5px auto;
            height: 300px;
        }

        .item__content {
            opacity: 0;
            width: 280px;
            padding: 20px 15px;
            transform: translate3d(-50%, 100%, 0);
        }

        .tendencies__text {
            font-size: 0.875rem;
            text-align: center;
        }

        .modal-container {
            width: calc(100% - 30px);
            height: 500px;
            overflow: auto;
            flex-direction: column;
            padding: 40px 25px 20px 25px;
        }

        .modal .modal__close {
            max-width: 13px;
            right: 12px;
            top: 12px;
        }

        .modal__content {
            margin-left: 0;
            margin-top: 0px;
        }

        .modal__flag {
            margin-bottom: 10px;
        }

        .modal__image {
            width: 100%;
            flex-shrink: 0;
            margin-bottom: 10px;
            height: auto;

            &__img {
                width: 100%;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center center;
                margin-right: 20px;
                height: 200px;
                border-radius: 4px;

                position: relative;
            }

            img {
                width: 100%;
            }

            &__list {
                max-width: 100%;
                margin-top: 15px;
                display: flex;
                justify-content: normal;
                flex-wrap: wrap;

                &__item {
                    width: 39px !important;
                    height: 39px;
                    margin: 0 3px 12px 3px;
                }
            }
        }

        .modal__content__title {
            font-size: 1.375rem;
        }

        .modal__content h3 {
            margin-top: 10px;
            font-size: 1rem;
        }

        .modal__content__desc {
            white-space: pre-line;
            font-size: 0.875rem;
            color: #4d4d4d;
            line-height: 24px;
            padding-right: 10px;
        }
    }
</style>